import WarehouseShipmentPanel from '../components/WarehouseShipmentPanel';
import WarehouseAssignment from '../components/WarehouseAssignment';
import { collectionStatus } from '../utils/collectionPresentation';
import ProductIdentity from '../components/ProductIdentity';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api, { logoutSession } from '../api';
import AdminPaymentCheck from '../components/AdminPaymentCheck';
import AdminSupplierPanel, { AdminCreateSeller } from '../components/AdminSupplierPanel';
import '../styles/adminPaymentCheck.css';
import '../styles/adminSupplier.css';
import { FULFILLMENT_STATUS_LABELS as STATUS_LABELS, ADMIN_NEXT_ACTION } from '../constants/fulfillmentStatus';

function AdminDashboard() {
  const [admin, setAdmin] = useState(() => {
    const saved = localStorage.getItem('admin');
    return saved ? JSON.parse(saved) : null;
  });
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(() => new URLSearchParams(window.location.search).has('paymentAttemptId') ? 'payments' : 'orders');
  const [orders, setOrders] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/admin/login', { email, password });
      // Новый формат: { admin, accessToken, refreshToken }
      const adminData = res.data.admin || res.data;
      localStorage.setItem('admin', JSON.stringify(adminData));
      if (res.data.accessToken) localStorage.setItem('adminAccessToken', res.data.accessToken);
      if (res.data.refreshToken) localStorage.setItem('adminRefreshToken', res.data.refreshToken);
      setAdmin(adminData);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка входа');
    }
  };

  const handleLogout = async () => {
    await logoutSession('admin');
    setAdmin(null);
    setSelectedSupplier(null);
    setSelectedOrder(null);
  };

  const loadOrders = async () => {
    try {
      const res = await api.get('/api/admin/orders');
      setOrders(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadSellers = async () => {
    try {
      const res = await api.get('/api/admin/sellers');
      setSellers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadOrderDetail = async (id) => {
    try {
      const res = await api.get(`/api/admin/orders/${id}`);
      setSelectedOrder(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/api/admin/orders/${id}/status`, { status });
      if (selectedOrder?.id === id) {
        setSelectedOrder(prev => ({ ...prev, fulfillmentStatus: status }));
      }
      loadOrders();
    } catch (err) {
      alert('Ошибка обновления статуса');
    }
  };

  useEffect(() => {
    if (admin) {
      loadOrders();
      loadSellers();
    }
  }, [admin]);

  if (!admin) {
    return (
      <div style={{ maxWidth: 400, margin: '40px auto', background: 'white', borderRadius: 16, padding: 32, boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 20, color: '#1e293b' }}>Вход администратора</h2>
        {error && <p style={{ color: 'red', marginBottom: 10 }}>{error}</p>}
        <form onSubmit={handleLogin}>
          <input placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required
            style={{ width: '100%', padding: 12, marginBottom: 12, borderRadius: 8, border: '1px solid #e2e8f0' }} />
          <input placeholder="Пароль" type="password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{ width: '100%', padding: 12, marginBottom: 12, borderRadius: 8, border: '1px solid #e2e8f0' }} />
          <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: 12, fontWeight: 600 }}>Войти</button>
        </form>
      </div>
    );
  }

  const confirmCollectedReturn = async () => {
    if (!window.confirm('Все забранные товары уже возвращены продавцам?')) return;
    try {
      await api.post(`/api/admin/orders/${selectedOrder.id}/return-collected`);
      await loadOrderDetail(selectedOrder.id);
      await loadOrders();
    } catch (err) {
      window.alert(err.response?.data?.error || 'Не удалось подтвердить возврат');
    }
  };

  if (selectedOrder) {
    const warehouseOrder = selectedOrder.shipments?.some(s => s.packingSnapshot?.mode === 'CONSOLIDATED');
    return (
      <div className="operations-workspace" style={{ minHeight: '100vh', background: '#f8fafc' }}>
        <header style={{ background: 'linear-gradient(135deg, #4C1D95 0%, #7C3AED 100%)', color: 'white', padding: '14px 30px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 24, fontWeight: 700 }}>MaxMarket Admin</span>
          <button onClick={() => setSelectedOrder(null)} className="btn btn-outline" style={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)' }}>Назад к заказам</button>
        </header>
        <div style={{ maxWidth: 1000, margin: '30px auto', padding: '0 20px' }}>
          <h2>Заказ №{selectedOrder.id}</h2>
          <p><strong>Клиент:</strong> {selectedOrder.customerName || '—'}</p>
          <p><strong>Телефон:</strong> {selectedOrder.customerPhone}</p>
          <p><strong>Статус сборки:</strong> {STATUS_LABELS[selectedOrder.fulfillmentStatus] || selectedOrder.fulfillmentStatus}</p>
          <p><strong>Сумма:</strong> {selectedOrder.totalAmount ? `${selectedOrder.totalAmount} ₽` : '—'}</p>

          {!warehouseOrder && ADMIN_NEXT_ACTION[selectedOrder.fulfillmentStatus] && (
            <div style={{ margin: '20px 0', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button
                onClick={() => updateStatus(selectedOrder.id, ADMIN_NEXT_ACTION[selectedOrder.fulfillmentStatus].target)}
                className="btn btn-primary"
                style={{ padding: '6px 14px', fontSize: 13 }}>
                {ADMIN_NEXT_ACTION[selectedOrder.fulfillmentStatus].label}
              </button>
            </div>
          )}

          {selectedOrder.collection && (
            <p>{collectionStatus(selectedOrder)} · получено {selectedOrder.collection.collected} из {selectedOrder.collection.total}</p>
          )}
          {selectedOrder.collection?.returnPending && (
            <button className="btn btn-outline" onClick={confirmCollectedReturn}>Товары возвращены продавцам</button>
          )}
          {warehouseOrder && selectedOrder.warehouseShippingEnabled && selectedOrder.status === 'PAID'
            && (selectedOrder.fulfillmentStatus === 'waiting' || (selectedOrder.collection?.canCollect && !selectedOrder.shipments.some(s => s.packingConfirmedAt))) && (
              <WarehouseAssignment key={selectedOrder.id} order={selectedOrder} onAssigned={() => loadOrderDetail(selectedOrder.id)} />
          )}
          {selectedOrder.collectorId && <p><Link to="/collector">Открыть кабинет сборщика</Link></p>}
          <WarehouseShipmentPanel key={selectedOrder.id} order={selectedOrder} onRefresh={() => loadOrderDetail(selectedOrder.id)} />
          {selectedOrder.sellerOrders?.map(so => (
            <div key={so.id} style={{ background: 'white', borderRadius: 12, padding: 20, marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
              <h4 style={{ color: '#7C3AED', marginBottom: 12 }}>Продавец: {so.seller?.name || `ID ${so.sellerId}`}</h4>
              <div className="product-table-scroll"><table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                    <th style={{ textAlign: 'left', padding: '8px 0' }}>Товар</th>
                    <th style={{ textAlign: 'left', padding: '8px 0' }}>Размер</th>
                    <th style={{ textAlign: 'left', padding: '8px 0' }}>Кол-во</th>
                    <th style={{ textAlign: 'left', padding: '8px 0' }}>Цена</th>
                  </tr>
                </thead>
                <tbody>
                  {so.items?.map(item => (
                    <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '8px 0' }}><ProductIdentity product={item} /></td>
                      <td style={{ padding: '8px 0' }}>{item.orderItem?.variant?.size || '—'}</td>
                      <td style={{ padding: '8px 0' }}>{item.quantity}</td>
                      <td style={{ padding: '8px 0' }}>{item.price} ₽</td>
                    </tr>
                  ))}
                </tbody>
              </table></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="operations-workspace" style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <header className="admin-dashboard-header" style={{ background: 'linear-gradient(135deg, #4C1D95 0%, #7C3AED 100%)', color: 'white', padding: '14px 30px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)' }}>
        <span style={{ fontSize: 24, fontWeight: 700, letterSpacing: -0.5 }}>MaxMarket Admin</span>
        <div style={{ display: 'flex', gap: 25 }}>
          {['orders', 'sellers', 'payments'].map(tab => (
            <button key={tab} role="tab" aria-selected={activeTab === tab} onClick={() => setActiveTab(tab)}
              style={{ background: 'transparent', border: 'none', color: activeTab === tab ? 'white' : 'rgba(255,255,255,0.7)', fontWeight: activeTab === tab ? 600 : 400, fontSize: 15, cursor: 'pointer', borderBottom: activeTab === tab ? '2px solid white' : '2px solid transparent', paddingBottom: 4 }}>
              {tab === 'orders' ? 'Заказы' : tab === 'sellers' ? 'Продавцы' : 'Проверка оплаты'}
            </button>
          ))}
        </div>
        <button onClick={handleLogout} className="btn btn-outline" style={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)', fontSize: 14, padding: '6px 16px' }}>Выйти</button>
      </header>

      <div style={{ maxWidth: 1300, margin: '30px auto', padding: '0 20px' }}>
        {activeTab === 'payments' && <AdminPaymentCheck />}
        {activeTab === 'orders' && (
          <>
            <h2 style={{ fontWeight: 700, color: '#1e293b', marginBottom: 20 }}>Заказы клиентов</h2>
            {orders.length === 0 ? <p>Нет заказов</p> : (
              <div className="product-table-scroll"><table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <thead>
                  <tr style={{ background: '#f1f5f9' }}>
                    <th style={{ padding: 12, textAlign: 'left' }}>№</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Товары</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Клиент</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Телефон</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Продавцы</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Сумма</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Статус</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Дата</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(o => (
                    <tr key={o.id} onClick={() => loadOrderDetail(o.id)} style={{ cursor: 'pointer', borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: 12 }}>{o.id}</td>
                      <td style={{ padding: 12 }}>
                        {o.sellerOrders?.flatMap(so => so.items || []).slice(0, 2).map(item => <ProductIdentity key={item.id} product={item} size={36} />)}
                      </td>
                      <td style={{ padding: 12 }}>{o.customerName || '—'}</td>
                      <td style={{ padding: 12 }}>{o.customerPhone}</td>
                      <td style={{ padding: 12 }}>{o._count?.sellerOrders || o.sellerOrders?.length || 0}</td>
                      <td style={{ padding: 12 }}>{o.totalAmount ? `${o.totalAmount} ₽` : '—'}</td>
                      <td style={{ padding: 12 }}>{o.collection ? `${collectionStatus(o)} · ${o.collection.collected}/${o.collection.total} · ${o.collector?.name || 'Сборщик не назначен'}` : (STATUS_LABELS[o.fulfillmentStatus] || o.fulfillmentStatus)}</td>
                      <td style={{ padding: 12 }}>{new Date(o.createdAt).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table></div>
            )}
          </>
        )}

        {activeTab === 'sellers' && (
          <>
            <h2 style={{ fontWeight: 700, color: '#1e293b', marginBottom: 20 }}>Продавцы</h2>
            <AdminCreateSeller onCreated={seller => {
              setSellers(current => [seller, ...current]);
              if (seller.managedByMaxMarket) setSelectedSupplier(seller);
            }} />
            {selectedSupplier && <AdminSupplierPanel key={selectedSupplier.id} seller={selectedSupplier} onClose={() => setSelectedSupplier(null)} />}
            {sellers.length === 0 ? <p>Нет продавцов</p> : (
              <div className="product-table-scroll"><table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <thead>
                  <tr style={{ background: '#f1f5f9' }}>
                    <th style={{ padding: 12, textAlign: 'left' }}>Имя</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Email</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Товаров</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Режим работы</th>
                    <th style={{ padding: 12, textAlign: 'left' }}>Дата регистрации</th>
                  </tr>
                </thead>
                <tbody>
                  {sellers.map(s => (
                    <tr key={s.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: 12 }}>{s.name}</td>
                      <td style={{ padding: 12 }}>{s.email}</td>
                      <td style={{ padding: 12 }}>{s._count?.products || 0}</td>
                      <td style={{ padding: 12 }}>{s.managedByMaxMarket
                        ? <button type="button" onClick={() => setSelectedSupplier(s)}>Поставщик MaxMarket · Управлять</button>
                        : 'Самостоятельный продавец'}</td>
                      <td style={{ padding: 12 }}>{new Date(s.createdAt).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table></div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
